module.exports = __webpack_public_path__ + "static/media/user-admin.9d235eac.png";